import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
export const CanvasFormTabsContext = createContext({
    selectedTab: 'Required',
    setSelectedTab: () => void 0,
});
export const CanvasFormTabsProvider = ({ tab = 'Required', children, }) => {
    const [selectedTab, setSelectedTab] = useState(tab);
    return (_jsx(CanvasFormTabsContext.Provider, { value: {
            selectedTab,
            setSelectedTab,
        }, children: children }));
};
export const FormTabsModes = {
    Required: 'Shows Required fields only',
    All: 'Shows All fields',
    Modified: 'Shows Modified fields only',
};
//# sourceMappingURL=canvas-form-tabs.provider.js.map